import './axios.config';
import { common } from './common';
import { article } from './article';

const services = {
    common,
    article
};

export default services;
